<template>
    <div
        v-if="loading"
        class="loader"
    >
        <img src="/images/loader.gif" alt="loading" class="img-fluid"/>

        <p v-if="text" class="py-2">
            {{ text }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false
        },

        text: {
            type: String,
            required: false
        }
    }
}
</script>
